import { Injectable, OnDestroy } from '@angular/core';
import { Store, StoreSelection } from '../models/store';
import { BehaviorSubject } from 'rxjs';
import { share } from 'rxjs/operators';

const SELECTED_STORE_IDENTIFIER: string = "selectedstore";

@Injectable({
  providedIn: 'root'
})
export class StoreSelectorService implements OnDestroy {

	private storeSubject = new BehaviorSubject<StoreSelection>(null);

	// Components / Services can subscribe to changes 
	public storeChanges = this.storeSubject.asObservable().pipe(share());

	// Sets the current selected store to the one stored in local storage.
	// If local storage is unset, the value remains null
	private setSelectedStoreFromLocalStorage(): StoreSelection {
		let storageItem = localStorage.getItem(SELECTED_STORE_IDENTIFIER);
		if (storageItem === null)
			return null;

		let selectedStore: StoreSelection = JSON.parse(storageItem);
		if(selectedStore != null) {
			this.storeSubject.next(selectedStore);
		}
	}

	// Set from local storage on startup
	constructor() {
		this.setSelectedStoreFromLocalStorage();
	}

	ngOnDestroy() {
	  	this.storeSubject.complete();
	}

	public getSelectedStore(): StoreSelection {
		return this.storeSubject.getValue();
	}
  
	// Set the local storage to contain a new Selected Store
	public setSelectedStore(store: Store) {
		let selectedStore = new StoreSelection();
		selectedStore.storeGuid = store != null ? store.storeGuid : null;
		selectedStore.name = store != null ? store.name : null;
		localStorage.setItem(SELECTED_STORE_IDENTIFIER, JSON.stringify(selectedStore));
		this.storeSubject.next(selectedStore);
	}
}
